
<template>
  <div class="settle">
      <div class="head">
          <div class="top">

            <Head :info="headInfo" @outSearch='search'></Head>
          </div>
          <div class="tabs-box">

        <Tabs :tabsList="tabsList" @change="changeTab"/>
          </div>
      </div>
    <div class="body">
        <div class="list-body">
            <div class="each" v-for="(item,index) in list" :key="index">
                <div class="top">
                    <!-- <img src="../../assets/images/company_default.png" alt=""> -->
                    <div class="type"><span>{{item.companyName}}</span></div>
                    <div class="state"> 
                        <img v-if="item.customerState==1" src="../../assets/images/try.png" alt="">
                        <img v-if="item.customerState==2" src="../../assets/images/ok.png" alt="">
                        {{item.customerState}}</div>
                </div>
                <div class="main">
                    <div class="company"><span class="label">● {{item.fullName}}</span>
                    <span>注册时间：{{item.registerDate}}</span>
                    </div>
                    <div v-if="item.customerState==2" class="company"><span class="label"><span>●</span> 购买金额：<span>{{item.buyTotal}}</span></span>
                    <span>购买时间：{{item.firstchargedate}}</span>
                    </div>
                    <div class="contact"><img class="suo" src="../../assets/images/suo.png" alt="">联系人：{{item.contactor}} {{item.phone}} <img @click="getPhone(item.companyId)" src="../../assets/images/call.png" alt=""></div>
                    
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'
import Tabs from '@/component_basics/Tabs'
import {ls} from '@/utils/localStorage'

// 组件
export default {
  name: 'curstomer',
  components: {Head,Cell,Tabs},
  data() {
    return {
        headInfo:{
            name: '客户管理',
            type:'search',
            placeholder:'客户公司名/电话/联系人'
        },
        // param: {
        //     monthTime: '',
        //     state:'',
        //     // refereeId: ls.get('refereeId')
        // },
        settleDic:{
            1:'结算中',
            2:'已结算'
        },
        list:[],
        img1: require('../../assets/images/doing.png'),
        img2: require('../../assets/images/over.png'),
        tabsList: [{
                title: '客户类型',
                label: 'customerState',
                value: 0,
                items:[
                    {
                        text: '全部类型',
                        value:0
                    },{
                        text: '试用',
                        value: 1
                    },{
                        text: '正式',
                        value:2
                    }
                ]
            },{
                title: '产品版本',
                label: 'productId',
                value: 0,
                items:[
                    {text: '全部',value: 0},
                    {
                        text: '管家婆云进销存',
                        value:28
                    },{
                        text: '管家婆网店ERP',
                        value: 29
                    }
                ]
            },{
                title: '排序',
                label: 'sortByFiled',
                value: 0,
                items:[
                    {
                        text: '注册时间升序',
                        value:1
                    },{
                        text: '注册时间降序',
                        value: 2
                    },{
                        text: '购买时间升序',
                        value:3
                    },{
                        text: '购买时间降序',
                        value:4
                    },{
                        text: '版本',
                        value:5
                    },{
                        text: '购买金额升序',
                        value:6
                    },{
                        text: '购买金额降序',
                        value:7
                    }
                ]
            }
        ],
        param:{
            productId:0,  //产品编号(默认0查询全部)
            // refereeId:ls.get('refereeId'),
            sortByFiled:2, //排序(1=注册时间升序,2=注册时间降序（默认）,3=购买时间升序,4=购买时间降序,5=版本,6=购买金额升序,7=购买金额降序)
            customerState: 0 // 客户类型0=全部(默认)， 1=试用，2=正式
        },
        disabled:true, 
        value:'',
        checked:''
        
    };
  },
  created() {
      this.getList()
  },
 mounted() {
 },
  methods: {
      changeTab(obj){
        //   alert(obj)
          this.param[obj.type] = obj.value
          this.getList() 
      },
      getList() {
          this.$services.companyList({method:'post',type: 'json',data:this.param}).then(res=> {
              console.log(res)
              this.list = res.data
          })
      },
      search(obj) {
          console.log(obj)
          this.param.keyWords = obj.search
          this.getList()
      },
      getPhone(id) {
          let param = {
              companyId:id
          }
          this.$services.getPhone({method:'post',data:param}).then(res=> {
              window.location.href = 'tel:'+res.data
          })
      }
  }
};
</script>

<style lang="less" scoped>
.settle{
    background-color: @colorBg;
    .head{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        .top{
        height: 40px;

        }
    }
    .list-body{
        padding: 90px 13px 13px 13px;
        .each{
            background-color: #fff;
            border-radius: 6px;
            margin-top: 16px;
            padding: 10px 18px;
            .top{
                height: 32px;
                border-bottom: 1px solid #e6e6e6;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 8px;
                img{
                    width: 20px;
                    height: 20px;
                    margin-right: 4px;
                }
                .type{
                    flex: 1;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 16px;
                    font-weight: bold;
                    span{
                        font-size: 14px;
                        font-weight: normal;
                    }
                }
                .state{
                    padding: 7px 10px;
                    border-radius: 4px;
                    font-weight: bold;
                    color: #605E5F;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 14px;
                        height: 14px;
                    }
                }
                .doing{
                    background-color: #DCEFE6;
                    color: #4BB57E;
                }
            }
            .main{
                display: flex;
                flex-direction: column;
                align-items: stretch;
                .company{
                    font-size: 12px;
                    color: @colorFont;
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                    span{
                        color: #A4A4A4;
                    }
                    .label{
                        span{
                            color: #F36938;
                        }
                    }
                    .point{
                        font-size: 20px;
                    }
                }
                .contact{
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 10px;
                    align-items: center;
                    img{
                        width: 14px;
                        height: 14px;
                        margin: 0 4px;
                    }
                    .suo{
                        width: 8px;
                        height: 10px;
                        margin-left: 0;
                    }
                }
            }
        }
    }
}
</style>
